import {
  takeLatest,
  put,
  select,
  take,
  call,
  cancel,
} from 'redux-saga/effects';
import { isEmpty, omitBy, get } from 'lodash';
import routes from '../../../constants/routes';
import {
  redirectToPayment,
  redirectToProviders,
} from '../../../utils/appointments/redirect-utils';
import * as userDetails from '../requests/user-details-req';
import * as necessaryData from '../requests/necessary-data-preparing-req';
import {
  APPOINTMENT_PROGRESS_TYPES,
  appointmentProgressActions,
} from '../progress-types';
import {
  selectProgressSSN,
  selectHealthInfoForm,
  selectProgressCareUser,
  selectProgressPatientForm,
  selectPreferredPharmacy,
  selectProgressOrganizationId,
  selectProgressIsRescheduleData,
  selectProgressCareUserId,
  selectUpdateNecessaryDataPending,
} from '../selectors';

function* detectFlow() {
  const isRescheduleFlow = yield select(selectProgressIsRescheduleData);
  const careUserId = yield select(selectProgressCareUserId);

  if (
    window.location.pathname.includes(routes.APPOINTMENT_FORM_EMERGENCY_CONTACT)
  ) {
    yield put(userDetails.actions.send({ id: careUserId }));

    yield cancel();
  }

  if (window.location.pathname.includes(routes.APPOINTMENT_FORM_PHARMACY)) {
    yield put(appointmentProgressActions.determineNextStepAfterPharmacy());

    yield cancel();
  }

  // used only for urgent virtual visit type
  if (window.location.pathname.includes(routes.APPOINTMENT_FORM_HEALTH_INFO)) {
    yield call(redirectToPayment);

    yield cancel();
  }

  if (!isRescheduleFlow) {
    yield call(redirectToProviders);
  }
}

function* handleUpdate(action) {
  const { id: userId } = yield select(selectProgressCareUser);
  const patientForm = yield select(selectProgressPatientForm);
  const healthInfoForm = yield select(selectHealthInfoForm);
  const pharmacyId = yield select(selectPreferredPharmacy);
  const organizationId = yield select(selectProgressOrganizationId);
  const ssn = yield select(selectProgressSSN);

  const profile = omitBy(patientForm, isEmpty);
  const payload = omitBy({ profile, ssn, healthInfoForm }, isEmpty);

  const finishAction = get(action, 'meta.finishAction');
  const data = get(action, 'payload');

  if (!isEmpty(payload) || !isEmpty(data)) {
    yield put(
      necessaryData.actions.send({
        userId,
        payload: {
          ssn,
          profile,
          ...data,
          ...(pharmacyId && { pharmacyId }),
          organizationId,
          ...healthInfoForm,
        },
      }),
    );
    yield take(necessaryData.consts.SUCCEED);

    if (finishAction) {
      yield call(finishAction);
      yield put(userDetails.actions.send({ id: userId }));

      yield cancel();
    }
    yield call(detectFlow);
  }

  yield call(detectFlow);
}

export default function* updateNecessaryData() {
  yield takeLatest(
    APPOINTMENT_PROGRESS_TYPES.UPDATE_NECESSARY_DATA,
    handleUpdate,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/update-data-saga.js